import { createContext, Dispatch, FC, ReactNode, SetStateAction, useMemo, useState } from "react"

export enum DragTypes {
  NONE = "NONE",
  TASK = "TASK",
  TASKGROUP = "TASKGROUP",
  PROJECT = "PROJECT",
  FILE = "FILE",
}

// Global drag type context
export const DragTypeContext = createContext<{
  dragType: DragTypes | null
  setDragType: Dispatch<SetStateAction<DragTypes | null>>
}>({ dragType: null, setDragType: () => {} })

export const DragTypeContextProvider: FC<{ children: ReactNode }> = ({ children }) => {
  const [dragType, setDragType] = useState<DragTypes | null>(null)

  const value = useMemo(() => ({ dragType, setDragType }), [dragType])

  return <DragTypeContext.Provider value={value}>{children}</DragTypeContext.Provider>
}

export default DragTypeContextProvider
